import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { CustomInfoIcon } from '../../../theme/icons/CustomInfoIcon';

export interface InfoBannerItem {
  id: string;
  content: ReactNode;
}

interface InfoBannerQueueProps {
  banners: InfoBannerItem[];
}

const InfoBannerQueue = ({ banners }: InfoBannerQueueProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex((prev) => Math.min(prev, Math.max(banners.length - 1, 0)));
  }, [banners.length]);

  if (banners.length === 0) {
    return null;
  }

  const currentIndex = Math.min(index, banners.length - 1);

  return (
    <Flex
      align="center"
      gap={3}
      mt={3}
      px="14px"
      py="8px"
      bg="rgba(0, 155, 214, 0.1)"
      borderRadius="5px"
    >
      <CustomInfoIcon color="#009BD6" boxSize="21px" flexShrink={0} />
      <Text fontSize="14px" color="rgba(0, 0, 0, 0.8)" flex={1}>
        {banners[currentIndex].content}
      </Text>
      {banners.length > 1 && (
        <Flex align="center" gap={1} flexShrink={0}>
          <IconButton
            aria-label="Previous message"
            icon={<ChevronLeftIcon />}
            size="xs"
            variant="ghost"
            onClick={() =>
              setIndex((i) => (i - 1 + banners.length) % banners.length)
            }
          />
          <Text fontSize="12px" color="rgba(0, 0, 0, 0.6)" whiteSpace="nowrap">
            {currentIndex + 1}/{banners.length}
          </Text>
          <IconButton
            aria-label="Next message"
            icon={<ChevronRightIcon />}
            size="xs"
            variant="ghost"
            onClick={() => setIndex((i) => (i + 1) % banners.length)}
          />
        </Flex>
      )}
    </Flex>
  );
};

export default InfoBannerQueue;
